// extracted by mini-css-extract-plugin
export default {"tools":"ToolList_tools__VMQfp","tool":"ToolList_tool__XtU6O"};